import type {AgentPerson} from 'api/types';
import type {TableConfiguration} from 'schema/table/types';
import {defaultTableConfig} from 'schema/table/configuration/defaultTableConfig';
import {publisherAgentDefaultColumns} from './columns';

export const publisherAgentTableConfig: TableConfiguration<AgentPerson> = {
  ...defaultTableConfig,
  defaultColumns: publisherAgentDefaultColumns,
};
